import { render, staticRenderFns } from "./new_trusteeship.vue?vue&type=template&id=34ac57a0&scoped=true&"
import script from "./new_trusteeship.vue?vue&type=script&lang=js&"
export * from "./new_trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeship.vue?vue&type=style&index=0&id=34ac57a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac57a0",
  null
  
)

export default component.exports